import { computed, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import { Sentry } from '@shared/sentry';
import { Analytics } from '@shared/analytics';
import { vueQueryLib } from '@shared/lib/vue-query-lib';

import { CountryToAPI } from '../api';
import { countriesToConfig } from '../config';

export function useCountryToQuery(townFromId: Ref<number | undefined>) {
  const isQueryEnabled = computed(() => townFromId.value !== undefined);

  const query = useQuery({
    queryKey: ['country-to-query-key', townFromId],
    queryFn: () =>
      CountryToAPI.getCountryTo(townFromId.value).then(res => res.data),
    staleTime: Infinity,
    enabled: isQueryEnabled,
  });

  vueQueryLib.withOnSuccess({
    query,
    onSuccess() {
      Analytics.logEvent({ event: countriesToConfig.analyticsEvents.SUCCESS });
    },
  });

  vueQueryLib.withOnError({
    query,
    onError(error) {
      Sentry.captureExWithCause('ERR_FAILED_TO_LOAD_COUNTRIES_TO', {
        cause: error,
      });

      Analytics.logEvent({ event: countriesToConfig.analyticsEvents.ERROR });
    },
  });

  return query;
}
